const root = '/secure-intake';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  request: baseRoute('/request'),
  upload: baseRoute('/upload'),
} as const;
